import * as yup from 'yup';

export default function(yupValidation: any, itemData: any) {
  let schema;
  let data;

  if ((typeof yupValidation).toLocaleLowerCase() === "object") {
    schema = schema = yup.object().shape(yupValidation);
    data = itemData;
  } else {
    schema = yup.object().shape({
      toValidate: yupValidation
    });
    data = {
      toValidate: itemData
    };
  }

  return schema
    .validate(data)
    .then(isValid => {
      return isValid;
    })
    .catch(error => error);
}



// WEBPACK FOOTER //
// ./src/lib/utils/simpleValidation.ts